export default class Saida {
  constructor(id, descricao, cliente, data, notafiscal, recebeu, setor, entregou) {
    this.id = id;
    this.descricao = descricao;
    this.cliente = cliente;
    this.data = data;
    this.notafiscal = notafiscal;
    this.recebeu = recebeu;
    this.setor = setor;
    this.entregou = entregou;
  }

  update(saida) {
    this.id = saida.id;
    this.descricao = saida.descricao;
    this.cliente = saida.cliente;
    this.data = saida.data;
    this.notafiscal = saida.notafiscal;
    this.recebeu = saida.recebeu;
    this.setor = saida.setor;
    this.entregou = saida.entregou;
  }
}
